import Button from '@Components/Buttons/Button'
import React, { useContext, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import ModalPortal from '@Components/Popups/ModalPortal'
import WorkMergeConfirmationPopup from '@Components/Popups/ConfirmationPopup/WorkMergeConfirmationPopup'
import { WorkMergeSteps } from '@App/stores/search/work/work-merge-bulk-action-store'

const WorkMergeFooter = () => {
    const { catalogSearchBulkActionStore, userStore, preloaderStore, popupStore } = useContext(StoresContext)
    const [reason, setReason] = useState('')
    const [displaySubmissionPopup, setDisplaySubmissionPopup] = useState(false)

    const isRequestReview = catalogSearchBulkActionStore.currentStep === WorkMergeSteps.RequestReview

    const handleBack = () => {
        if (catalogSearchBulkActionStore.isFirstStep) {
            catalogSearchBulkActionStore.setIsMergingWorks(false)
        } else {
            catalogSearchBulkActionStore.prevStep()
        }
        window.scrollTo(0, 0)
    }

    const handleConfirmGroup = () => {
        catalogSearchBulkActionStore.confirmCurrentGroup(reason)
        setReason('')
        window.scrollTo(0, 0)
    }

    const handleAddAnotherGroup = () => {
        catalogSearchBulkActionStore.startNewGroup()
        window.scrollTo(0, 0)
    }

    const handleSubmitAll = () => {
        preloaderStore.openTransparentPreloader(true)
        catalogSearchBulkActionStore
            .submitAllMergeRequests()
            .then(() => setDisplaySubmissionPopup(true))
            .catch((error) => popupStore.setAlertData(error.message, true))
            .finally(() => preloaderStore.openTransparentPreloader(false))
        window.scrollTo(0, 0)
    }

    return (
        <>
            <ModalPortal isOpen={displaySubmissionPopup}>
                <WorkMergeConfirmationPopup onClose={() => catalogSearchBulkActionStore.resetStore()} />
            </ModalPortal>
            {!isRequestReview && (
                <div className="reason">
                    <header>Reason (optional)</header>
                    <textarea value={reason} onChange={(e) => setReason(e.target.value)} />
                </div>
            )}
            <div className="footer">
                <Button type="secondary" mainColor onClick={handleBack}>
                    Back
                </Button>
                {isRequestReview ? (
                    <div className="footer-button-group">
                        <Button
                            type="secondary"
                            mainColor
                            onClick={handleAddAnotherGroup}
                            disabled={catalogSearchBulkActionStore.isGroupCapReached}
                        >
                            Start another merge request
                        </Button>
                        <Button
                            type="primary"
                            mainColor
                            onClick={handleSubmitAll}
                            disabled={
                                catalogSearchBulkActionStore.confirmedMergeGroups.length === 0 || userStore.isInternal
                            }
                        >
                            Submit Merge Request
                        </Button>
                    </div>
                ) : (
                    <Button
                        type="primary"
                        mainColor
                        onClick={handleConfirmGroup}
                        disabled={catalogSearchBulkActionStore.primaryWorkMergeId == null}
                    >
                        Review Merge Request
                    </Button>
                )}
            </div>
        </>
    )
}
export default observer(WorkMergeFooter)
